module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-tomatoChili.3b40fbf5.png";